module.exports = "../dist/frontend/icons/ui/back-to-top.svg?dec0397cd7324a0ee4b76bfb6f1b3bd9";